module.exports = __webpack_public_path__ + "static/tiefling-AYAGWW-f1f3713783a7b03b6c0fdfbac771d080.png";